import { render, staticRenderFns } from "./FormIndexActions.vue?vue&type=template&id=6e166a49&"
import script from "./FormIndexActions.vue?vue&type=script&lang=ts&"
export * from "./FormIndexActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports